import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getOperators = async () => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: '/schedule/user/operator/list',
  });

  return data;
};

export default getOperators;
